import mitt, { Emitter, EventType } from "mitt";
import { User } from "@/axios/interfaces/user";
import { General } from "@/types/general";

interface Events extends Record<EventType, unknown> {
  "refresh-list": unknown;
  "back-list": unknown;
  "choose-last-identity": User.IdentityEnumKey;
  "reset-publish-state": General.PublishStatusKey;
}

export default mitt() as Emitter<Events>;
